export default "__VITE_ASSET__BynUA17s__"